import { Checkbox } from 'semantic-ui-react';
import styled from 'styled-components';

export const InformationWrapper = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 15px;
 .label {
  font-weight: bold !important;
 }
 .value {
  color: #6c757d !important;
 }
`
export const StyledCheckbox = styled(Checkbox)`
display: flex !important;
justify-content: end !important;
margin-top: 20px;
 label {
  font-size: 15px !important;
 }
`